import script from "./TopPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPage.vue?vue&type=script&setup=true&lang=js"

import "./TopPage.vue?vue&type=style&index=0&id=2cb3d750&lang=scss"

const __exports__ = script;

export default __exports__